module.exports = __webpack_public_path__ + "static/CopCar-de5ceedfd6fdc862f9c5371c9636ef91.webm";